module.exports = __webpack_public_path__ + "img/沈阳好车芝嘛科技有限公司.191c6229.png";